import { CardActions } from "@mui/material";
import { styled } from '@mui/material/styles';

export const MprcCardActions = styled(CardActions)({
    paddingTop: "0rem",
    border: "0",
    borderRadius: "6px",
    justifyContent: "center !important"
});
